import { Box, IconButton, Typography } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { AvailabilitySlot, Session } from "../../utils/types";
import { format, parseISO } from "date-fns";
import { Link } from "react-router-dom";

type SessionsCreationFeedbackProps = {
    sessionsOrSlots: Array<Session | AvailabilitySlot>;
    message?: string;
};

export const SessionsCreationFeedback = ({ sessionsOrSlots, message }: SessionsCreationFeedbackProps) => {
    const formatSessionInfo = (slot: Session | AvailabilitySlot) => {
        const date = format(parseISO(slot.start_date), "dd/MM");

        const start = format(parseISO(slot.start_date), "HH:mm");

        return {
            date,
            time: `${start}`,
            service: "id" in slot ? slot.service.name : slot.serviceName,
        };
    };

    return (
        <Box sx={{ mb: 2, p: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold">
                {message}
            </Typography>
            {sessionsOrSlots.map((session) => {
                const { date, time, service } = formatSessionInfo(session);
                const isSession = "id" in session;
                const sessionPath = isSession ? `/sessions/${session.id}/detail` : undefined;

                return (
                    <Box key={isSession ? session.id : session.slotId} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {sessionPath ? (
                            <>
                                <Typography
                                    component={Link}
                                    to={sessionPath}
                                    variant="body2"
                                    sx={{ textDecoration: "none", color: "white"}}

                                >
                                    {`${date}: ${time} - ${service}`}
                                </Typography>
                                <IconButton component={Link} to={sessionPath} target="_blank" size="small" sx={{ p: 0 }}>
                                    <OpenInNew fontSize="small" sx={{color: "white"}}/>
                                </IconButton>
                            </>
                        ) : (
                            <Typography variant="body2">
                                {`${date}: ${time} - ${service}`}
                            </Typography>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};
